import to from 'await-to-js';
import get from 'lodash/get';
import {container} from 'op/container';
import {connect} from 'react-redux';
import {compose, withProps, withHandlers} from 'recompose';
import omitProps from '@hocs/omit-props';

import {withAxios} from 'op/components/auth';
import {withLanguageID} from 'op/components/locale';
import url from "url";

export const withTypes = compose(
    withAxios,
    connect(({lut}) => ({
        types: lut.types || [],
    }), (dispatch) => ({
        setTypes: (payload) =>
            dispatch(container.resolve('actions').load_table({table: 'types', payload})),
    })),
    withHandlers({
        fetchTypes: ({axios, setTypes}) => async () => {
            const {data} = await axios.get('/api/tasks/tasktypeselect');
            setTypes(data
                //.filter(type => type.isexpired ==false)
                .map(container.resolve('transformers').traning_event_type));
        },
    })
);

export const withCategories = compose(
    withAxios,
    connect(({lut}) => ({
        categories: lut.categories || {},
    }), (dispatch) => ({
        setCategories: (type, payload) =>
            dispatch(container.resolve('actions').load_complex_table({table: 'categories', type, payload})),
    })),
    withHandlers({
        fetchCategories: ({axios, categories, setCategories}) => async (typeID) => {
            const {data} = await axios.get(url.format({
                pathname: '/api/tasks/eventcategory',
                query: {typeID}
            }));
            setCategories(typeID.toString(), data
            //.filter(category => category.isexpired ==false)
            .map(container.resolve('transformers').traning_categories));
        }
    }),
);

export const withKpiTypes = compose(
    withAxios,
    connect(({lut}) => ({
        kpiTypes: lut.kpis || {},
    }), (dispatch) => ({
        setKpis: (type, payload) =>
            dispatch(container.resolve('actions').load_complex_table({table: 'kpis', type, payload})),
    })),
    withHandlers({
        fetchKpiTypes: ({axios, kpiTypes, setKpis}) => async (categoryId) => {
            try {
                const {data} = await axios.post('/api/kpi/sub_eval_type', {categoryID: categoryId});
                setKpis(categoryId.toString(), data.map(container.resolve('transformers').kpiType));
            } catch (ex) {
                console.error(ex);
            }
        }
    }),
);

export const withExecutionLevels = (typePropPath) =>
    compose(
        withAxios,
        withProps((props) => ({traningEventType: get(props, typePropPath)})),
        withLanguageID,
        connect(({lut}, {traningEventType}) => ({
            executionLevels: (traningEventType && lut.executionLevels && lut.executionLevels[traningEventType.toString()]) || [],
        }), (dispatch) => ({
            setExecutionLevels: (type, payload) =>
                dispatch(container.resolve('actions').load_complex_table({table: 'executionLevels', type, payload})),
        })),
        withHandlers({
            fetchExecutionLevels: ({axios, traningEventType, language, executionLevels, setExecutionLevels}) => async () => {
                const {data} = await axios.get(url.format({
                    pathname: '/api/common/getexecutionlevels',
                    query: {traningEventType, language}
                }));

                setExecutionLevels(traningEventType.toString(), data.map(container.resolve('transformers').execution_level));
            },
        }),
        omitProps('setExecutionLevels', 'traningEventType', 'language'),
    );
